module.exports = __webpack_public_path__ + "img/tools_Board_of_Directors_Remuneration.c95f298c.jpg";